import React from 'react';

export const USER_ROLES = {
	ADMIN: 'ADMIN',
	COORDINATOR: 'COORDINATOR',
	STUDENT: 'STUDENT',
};

const user = {
	currentUser: null,
	setCurrentUser: () => undefined,
};

export const CurrentUserContext = React.createContext(user);
